/* todo - deprecate this and use UserMixin instead? */
export default {
  data: function () {
    return {};
  },
  methods: {
    setAdmin(username) {
      localStorage.setItem("eyedockAdmin", username);
      this.$store.dispatch("setAdmin", username);
    },
    logoutAdmin() {
      localStorage.removeItem("eyedockAdmin");
      this.$store.dispatch("setAdmin", null);
    },
  },
  computed: {
    isAdmin: function () {
      return this.$store.state.admin;
    },
  },
  mounted() {
    if (localStorage.getItem("eyedockAdmin"))
      this.$store.dispatch("setAdmin", localStorage.getItem("eyedockAdmin"));
  },
};
